import React, { useMemo } from 'react'
import {
  buildPanelCheckItems,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseExtraFiltersInputs'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'

interface Props {
  filters: {
    isLuxPlus?: Set<string>;
  };
  onChange: (nextFilters: Record<string, any>) => void;
  facets: Array<App.CruiseSearchFacet>;
}

function CruiseLuxPlusFilter({
  filters,
  onChange,
  facets,
}: Props) {
  const luxPlusItems = useMemo(() => {
    const luxPlusFacets = facets
      .filter(facet => facet.category === 'lux_plus')
      .map(facet => ({
        ...facet,
        name: 'Bonus inclusions',
      }))
    return buildPanelCheckItems(luxPlusFacets)
  }, [facets])

  return <FilterPanelCheckboxGroup
    name="isLuxPlus"
    items={luxPlusItems}
    onChange={onChange}
    defaultSelected={filters.isLuxPlus}
  />
}

export default CruiseLuxPlusFilter
